export enum ApiURL {
  ANONYM_VERKTOYLISTE = 'api/v1/AnonymVerktoyliste',
  VERKTOYLISTE = 'api/v1/MinHelse/Verktoyliste',
  MINE_VERKTOY_V2 = 'innbygger/mineverktoy/v2',
  VERKTOY = 'api/v1/MinHelse/Verktoy',
  ANONYM_VERKTOY = 'api/v1/MinHelse/AnonymVerktoy',
  AVVIS_OPPGAVE = 'api/v1/MinHelse/AvvisOppgave',
  ANONYM_GRAFISKELEMENT = 'api/v1/GrafiskElement/AnonymBruk',
}

export enum VERKTOY_START_API_URLS {
  LOGG_START_VERKTOY = 'api/v1/MinHelse/LoggStartVerktoy',
  START_LTI_VERKTOY = 'api/v1/MinHelse/StartLtiVerktoy',
}
